export const PRIMARY = "#003CA6";
export const SECONDARY = "#CDDFFF";
export const LIGHT_COLOR_LAYOUT = "#53A2E3";
